import {handleHTTPError} from "../../components/ErrorFactory";
import {HTTPError} from "../../models/errors/HTTPError";
import {VerifyFormModel} from "../../models/forms/VerifyFormModel";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {delay} from "../delay";

export async function VerifyForm(body: VerifyFormModel) {
    // Input validation

    // Check that the form inputs are not null
    if (
        body.inputs.code.current == null
    ) {
        body.setBanner(handleHTTPError(406, "One or more inputs is currently empty."));
        return;
    }
    // Check that the turnstile challenge has been attempted
    else if (body.inputs.cfTurnstileToken.current === "null") {
        body.setBanner(handleHTTPError(406, "Captcha challenge has not been attempted."));
        return;
    }

    // Create API interface object
    const api = new ApiDataHelper(body.memory);

    // Register the user
    try {
        await api.Execute('/auth/verify', {
            body: JSON.stringify({
                code: body.inputs.code.current.value.trim(), // Removes whitespace
                cfTurnstileToken: body.inputs.cfTurnstileToken.current
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT'
        }, false, 0);

        // Inform the user the request was a success
        body.setBanner(handleHTTPError(200, "Your account has been verified you'll be redirected shortly..."));
        await delay(3000);
        body.memory.memory[0].Router('/login')
    }
    catch(e) {
        // If the error is a HTTP related exception
        if (e instanceof HTTPError) {
            // If a 403 occurs it means the access code was rejected
            if (e.code === 403) {
                body.setBanner(handleHTTPError(403, "Invalid verification code."));
            }
            else {
                body.setBanner(handleHTTPError(e.code, e.message));
            }
        }
        else {
            body.setBanner(handleHTTPError(999, ""));
        }
    }
}